import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <a href="https://www.zhihu.com" className="footer-link" target="_blank" rel="noopener noreferrer">知乎主页</a>
          <a href="https://space.bilibili.com/315087225" className="footer-link" target="_blank" rel="noopener noreferrer">Bilibili</a>
          <a href="https://github.com/BXRan" className="footer-link" target="_blank" rel="noopener noreferrer">Github</a>
        </div>
        
        <div className="footer-divider"></div>
        
        <div className="footer-info">
          <p>Copyright © {currentYear} 齐齐课堂. 保留所有权利。</p>
          <p>湘ICP备2020021716号-1</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 